import clsx from 'clsx'
import { Link as ReactRouterLink, LinkProps } from 'react-router-dom'

import classes from './link.module.scss'

interface Props extends LinkProps {
  variant?: 'link' | 'button'
}

export const Link = ({ className, variant = 'link', ...props }: Props) => (
  <ReactRouterLink {...props} className={clsx(className, classes[variant])} />
)
